import React from 'react'

const SlicknextCircle = ({ ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            {...props}
        >
            <circle
                cx="18"
                cy="18"
                r="17.5"
                transform="rotate(-180 18 18)"
                fill="white"
                stroke="black"
            />
            <path
                d="M9.09279 18.0006H26.9072M26.9072 18.0006C23.6273 18.0006 20.9691 20.5822 20.9691 23.7676M26.9072 18.0006C23.6273 18.0006 20.9691 15.419 20.9691 12.2336"
                stroke="black"
                strokeMiterlimit="10"
            />
        </svg>
    )
}

export default SlicknextCircle
